// windup 组件的 paceMs 值
export const PACEMS = 20;
